import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const ItemMenu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .content-item-menu {
    width: 100%;

    .img-item-menu-max {
      display: none;
      position: absolute;
      width: 0.7rem;
      left: -0.3rem;
      top: 0.13rem;
      cursor: pointer;
    }

    .img-item-menu-min {
      position: absolute;
      width: 0.7rem;
      left: -0.3rem;
      top: 0.13rem;
      cursor: pointer;
    }

    :hover {
      .img-item-menu-max {
        display: block;
      }
    }
  }
`;

export const ItemButtonMenu = styled.button`
  position: relative;
  width: 100%;
  height: 2.6rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem;
  border: 0;
  border-radius: 0.68rem;
  background: ${Colors.Color2};

  .bgColor {
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 0.5rem;
    ${({ selected, bgColorSelect }) => {
      if (selected && bgColorSelect) {
        return `background: ${bgColorSelect};`;
      } else {
        return `background: ${Colors.Color2};`;
      }
    }}

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.2rem;

    img {
      width: 1.3rem;
    }
  }

  p {
    ${({ selected, ftColorSelect, ftColor }) => {
      if (selected && ftColorSelect) {
        return `color: ${ftColorSelect};`;
      } else {
        return `color: ${ftColor};`;
      }
    }}
    font-size: 0.5rem;
    font-weight: 600;
    display: block;
    position: absolute;
    bottom: -0.7rem;
  }

  :hover {
    .bgColor {
      ${({ bgColorSelect }) => {
        return `background: ${bgColorSelect} !important;`;
      }}
    }

    p {
      display: block;
      ${({ ftColor }) => {
        return `color: ${ftColor};`;
      }}
    }
  }
`;

export const NotificationDot = styled.div`
  position: absolute;
  top: 3px;
  right: 8px;
  width: 8px;
  height: 8px;
  background: #ff4444;
  border-radius: 50%;
  z-index: 10;

  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
